module.exports = __webpack_public_path__ + "img/gys_24@2x.b06d419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_24@2x.png
// module id = lld0
// module chunks = 0